module.exports = __webpack_public_path__ + "static/media/caller_sound.a852f46e.mp3";